import { computed, ref, type ComponentPublicInstance } from 'vue';
import { ComponentMapping } from 'aem-vue-editable-components';
import { usePluginsThatProvideAemComponents } from './plugin';

interface TeleportComponent {
    component: ComponentPublicInstance;
    teleportTo: string;
    props?: Record<string, unknown>;
}

const teleportComponentList = ref<TeleportComponent[]>([]);

// Expose an API for AEM component to be able to mount a Vue component anywhere on the page.
export async function mountComponent(
    componentResourceType: string,
    teleportTo: string,
    props: Record<string, unknown> = {}
) {
    await usePluginsThatProvideAemComponents(new Set([componentResourceType]));
    const component = ComponentMapping.get<ComponentPublicInstance>(componentResourceType);
    if (component) {
        teleportComponentList.value.push({
            component,
            teleportTo,
            props
        });
    } else {
        throw new Error('Component does not exist.');
    }
}

export function useTeleportComponentList() {
    return computed(() => {
        return teleportComponentList.value;
    });
}
